import { memo } from "react";
import { FormattedMessage } from "react-intl";
import { RouterPath } from "routes/routerPaths";
import { useLocation, useNavigate } from "react-router-dom";
import { publicPath } from "request";
import { clsx } from "clsx";

interface IProps {
  product: any;
  isVoiceProduct?: boolean;
  isAllowClick?: boolean;
}

export const ProductRow = memo(
  ({ product, isVoiceProduct, isAllowClick }: IProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { state } = location;

    const getLanguages = (productSoundLocalList: any): string => {
      if (!productSoundLocalList || productSoundLocalList?.length === 0)
        return "";
      return productSoundLocalList
        ?.map(({ langDesc }: any) => langDesc)
        .join("/");
    };

    const onToCommandPage = () => {
      if (!isAllowClick) return;

      navigate(`/${RouterPath.voiceCommand}`, {
        state: {
          token: state.token,
          lang: state.lang,
          productId: product.productId,
          productName: product.productName,
          picture: product.picture,
        },
      });
    };

    return (
      <div
        className="bg-white dark:bg-gray323434 rounded px-4 py-4 flex flex-row items-center mt-3"
        onClick={onToCommandPage}
      >
        <div className="w-16 flex items-center justify-center">
          <img
            src={product?.picture}
            className="w-auto max-w-[56px] h-auto max-h-20"
            alt="Product"
          />
        </div>
        <div className="px-3 flex-1">
          <div className="flex flex-col">
            <span className="text-base font-medium">
              {product?.productName}
            </span>
            <span
              className={clsx("leading-4 text-xs text-gray999 inline-block", {
                "mt-3": isAllowClick,
              })}
            >
              {product?.model}
            </span>
          </div>
          {isVoiceProduct && !isAllowClick && (
            <div className="flex flex-col mt-3">
              <span>
                <FormattedMessage id="thirdParty.connect.support.language" />
              </span>
              <span className="text-gray999 text-sm leading-4">
                {getLanguages(product?.productSoundLocalList)}
              </span>
            </div>
          )}
        </div>
        {isAllowClick && (
          <img
            src={`${publicPath}/icons/ic_more@2x.png`}
            className="w-[6px] flex-shrink-0"
            alt=""
          />
        )}
      </div>
    );
  }
);
